import { Link } from "react-router-dom";
import { literals } from "@/constants/literals";
import { Icon } from "@/components/icons/Icon";
import type { IconName } from "@/components/icons/icons";

export interface SectionLinkProps {
  linkTo: "capture" | "admin";
}
const SectionLink = ({ linkTo }: SectionLinkProps) => {
  const linkElements = {
    to: linkTo === "capture" ? "capture" : "admin/photos",
    text: linkTo === "capture" ? literals.takePhoto : literals.seePhotos,
    icon: linkTo === "capture" ? "addPicture" : "photos",
  };

  return (
    <Link
      className="h-full flex-1 border border-ib-pt-color-red-1000 rounded-sm flex flex-col items-center justify-center gap-y-4 text-ib-pt-color-red-500 hover:text-ib-pt-color-red-800 hover:bg-ib-pt-color-red-300"
      to={linkElements.to}
    >
      <div className="w-[50%] max-w-[120px] h-[50%] max-h-[120px]">
        <Icon name={linkElements.icon as IconName} className="size-[100%]" />
      </div>
      <div>{linkElements.text}</div>
    </Link>
  );
};

export default SectionLink;
